module.exports = __webpack_public_path__ + "img/大黄.b3c3cbc3.jpg";